export const ROLE_PRIORITY_ORDER: string[] = [
	"program-director",
	"program-manager",
	"program-operations",
	"tech-team",
	"tech-support",
	"cohort-lead",
	"teaching-team",
	"community-rep",
	"judge",
	"mentor",
	"learner",
	"everyone",
];

export const ROLE_DISPLAY_NAMES: Record<string, string> = {
	"program-director": "Program Director",
	"program-manager": "Program Manager",
	"program-operations": "Operations Team",
	"tech-team": "Tech Team",
	"tech-support": "Tech Support",
	"teaching-team": "Teaching Team",
	"cohort-lead": "Cohort Lead",
	"community-rep": "Community Rep",
	judge: "Judge",
	mentor: "Mentor",
	learner: "Learner",
	everyone: "Everyone",
};
